import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { createApplicationListSync, type ApplicationListSync } from '@/lib/applicationListSync';

/** React binding for {@link ApplicationListSync} — single cache writer per tree. */
export function useApplicationListSync(): ApplicationListSync {
  const queryClient = useQueryClient();
  return useMemo(() => createApplicationListSync(queryClient), [queryClient]);
}
